import React, { useEffect } from 'react'
import { SocketState } from '../../../context/SocketProvider'
import { useDispatch, useSelector } from 'react-redux'
import { SET_CLAIM_TICKET_ID_3D, SET_CLAIM_TICKET_RECORD_3D, SelectClaimTicket3d, SelectClaimTicketRecord3d } from '../../../redux/3d_game_Slice/gameinfo3d'
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice'
import moment from 'moment'
import ModalContainerSmall from '../../../2d-game/modals/ModalContainerSmall'
import { setLoaderShow } from '../../../redux/seriesSlice'

function ClaimTicketModal3d() {
  const dispatch = useDispatch()
  const { socket } = SocketState()
  const claimTicketRecord = useSelector(SelectClaimTicketRecord3d)
  const ticketID = useSelector(SelectClaimTicket3d)

  useEffect(() => {
    if (ticketID.length >= 10) {
      claimTicket()
    }

  }, [ticketID])

  useEffect(() => {
    return () => {
      dispatch(SET_CLAIM_TICKET_RECORD_3D({}))
      dispatch(SET_CLAIM_TICKET_ID_3D(''))
    }
  }, [])

  let claimTicket = () => {
    dispatch(SET_MAIN_LOADER(true))
    var data = {
      "en": "PICK_THREE_TICKET_CLAIM",
      "data": {
        "ticket_id": ticketID,
      }
    }
    socket.emit("req", data);
    dispatch(SET_CLAIM_TICKET_ID_3D(''))
    // setTicketId('')

  }

  return (
    <ModalContainerSmall title={'Claim Ticket'} navigation={'/3d'} >
      <div className='w-full'>
        <div className='flex p-4'>
          <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Ticket No</p></div>
          <div className='w-1/2'> <input
            className="shadow appearance-none border border-gray-400 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            autoFocus={true}
            value={ticketID}
            onChange={(e) => dispatch(SET_CLAIM_TICKET_ID_3D(e.target.value))}
          /></div>
        </div>
        {/*  */}
        {claimTicketRecord.err ?
          <div className='flex flex-1 justify-center items-center pt-16 flex-col'>
            <p className='font-bold text-[20px] mb-20'>Ticket Id : {claimTicketRecord?.data.ticket_id}</p>
            <p className='font-bold text-[18px]'>{claimTicketRecord.msg}</p>
          </div>
          :
          <>
            <div className='flex p-4'>
              <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Draw Date Time</p></div>
              <div className='w-1/2'><p className='font-semibold text-[18px]'>{claimTicketRecord?.data?.deal_date} {claimTicketRecord?.data?.deal_time}</p> </div>
            </div>
            {/*  */}
            <div className='flex p-4'>
              <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Claim Date Time</p></div>
              <div className='w-1/2'><p className='font-semibold text-[18px]'>{claimTicketRecord?.deal_date ? moment().format('DD-MM-yyyy hh:mm:ss A') : ''}</p> </div>
            </div>
            {/*  */}
            <div className='flex p-4 justify-center'>
              {claimTicketRecord?.data?.msg &&
                <p className='font-semibold text-[18px] text-green-600'>
                  {claimTicketRecord?.data?.msg}
                </p>}
              {/* <div className='w-1/2 px-5'><p className='font-semibold text-[18px]'>Win No</p></div>
                    <div className='w-1/2'> </div> */}
            </div>
          </>
        }


      </div>
    </ModalContainerSmall>
  )
}

export default ClaimTicketModal3d
